import { Search } from 'projects/flow-gui-access/views/middlewares/search'
import { Soon, AccessExport, ServiceExport, BillingExport } from 'projects/flow-gui-access/views/middlewares/core'
import { About } from 'views/core'

module.exports = [
  {
    path: '/soon',
    exact: true,
    component: Soon
  }, {
    path: '/export/services',
    exact: true,
    component: ServiceExport
  }, {
    path: '/export/access',
    exact: true,
    component: AccessExport
  }, {
    path: '/export/billing/:id',
    exact: true,
    component: BillingExport
  }, {
    path: '/search',
    exact: true,
    component: Search
  }, {
    path: '/about',
    exact: true,
    component: About
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/core.js